import { RootLayout, createAppRouter } from "@neu/libui";

import { patientSubNavItems } from "#modules/patient/patientSubNavItems";
import { planSubNavItems } from "#modules/plan/planSubNavItems";

import {
	Analytics,
	AnalyticsEntityView,
	Chat,
	Dashboard,
	Patient,
	PatientDetail,
	Plan,
	PlanDetail,
	Settings,
	SettingsEntityView,
	SettingsRecordDetail,
	SettingsRecordList,
	patientNestedModuleListConfig,
} from "#modules";

export const router = createAppRouter({
	rootLayout: RootLayout,
	simpleRoutes: [
		{ path: "/dashboard", component: Dashboard },
		{ path: "/chat", component: Chat, pathParam: "roomID" },
	],
	nestedModules: [
		{
			path: "/patient",
			paramName: "patientID",
			entity: "patient",
			layout: Patient,
			detail: PatientDetail,
			subRoutes: patientSubNavItems,
			...patientNestedModuleListConfig,
		},
		{
			path: "/plan",
			paramName: "planID",
			entity: "plan",
			layout: Plan,
			detail: PlanDetail,
			subRoutes: planSubNavItems,
		},
		{
			path: "/settings",
			paramName: "entityName",
			entity: "settings",
			layout: Settings,
			detail: SettingsEntityView,
			listComponent: () => null,
			detailChildren: {
				listComponent: SettingsRecordList,
				detailComponent: SettingsRecordDetail,
				paramName: "recordID",
			},
		},
		{
			path: "/analytics",
			paramName: "entityKey",
			entity: "analytics",
			layout: Analytics,
			detail: AnalyticsEntityView,
			listComponent: () => null,
		},
	],
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
